<ng-container *transloco="let t;">
  <app-list-view [title]="t('common.labels.toolbox-candidates')" [messages]="messages" [loading]="loading">

    <div buttons>
      <button withRight="admin.toolboxcandidate.list" pButton (click)="onReload()" type="button" icon="pi pi-refresh" class="p-button-secondary p-button-outlined p-mb-2" aria-label="{{ t('common.labels.reload_list') }}" pTooltip="{{ t('common.labels.reload_list') }}" tooltipPosition="left"></button>
      <!-- <button withRight="admin.toolboxcandidate.export" pButton (click)="onShowExport()" type="button" icon="pi pi-file-excel" class="p-mb-2 p-ml-2" aria-label="{{ t('common.labels.export') }}" [label]="t('common.labels.export')"></button> -->
    </div>

    <div table>
      <p-table [value]="candidates" [paginator]="true" [rows]="20" stateStorage="local" stateKey="toolbox-candidates-list">
        <ng-template pTemplate="colgroup">
          <colgroup>
              <col>
          </colgroup>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
              <th pSortableColumn="fullname_reverse" aria-label="{{ t('common.labels.name') }}">{{ t('common.labels.name') }}
                  <p-sortIcon field="fullname_reverse"></p-sortIcon>
              </th>
              <th pSortableColumn="onlinetestname" aria-label="{{ t('common.labels.testtype') }}">{{ t('common.labels.testtype') }}
                  <p-sortIcon field="onlinetestname"></p-sortIcon>
              </th>
              <th pSortableColumn="status" aria-label="{{ t('common.labels.status') }}">{{ t('common.labels.status') }}
                  <p-sortIcon field="status"></p-sortIcon>
              </th>
              <th pSortableColumn="created_at" aria-label="{{ t('common.labels.created_at') }}">{{ t('common.labels.created_at') }}
                  <p-sortIcon field="created_at"></p-sortIcon>
              </th>
          </tr>

          <tr class="filter">
            <th>
              <p-columnFilter type="text" field="fullname_reverse" [matchMode]="'contains'"></p-columnFilter>
            </th>
            <th>
              <p-columnFilter type="text" field="onlinetestname" [matchMode]="'contains'"></p-columnFilter>
            </th>
            <th>
              <p-columnFilter type="text" field="translated_status_name" [matchMode]="'contains'"></p-columnFilter>
            </th>
            <th>
              <p-columnFilter type="date" field="created_as_date" [showMatchModes]="true" [showOperator]="false" [showAddButton]="false">
                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                  <p-calendar #calendar [ngModel]="value" (onSelect)="filter(calendar.value)" (onInput)="setup(calendar.value, 'created_as_date')" dateFormat="dd.mm.yy"></p-calendar>
                </ng-template>
              </p-columnFilter>
            </th>
          </tr>



        </ng-template>
        <ng-template pTemplate="body" let-candidate>
            <tr (click)="onOpen(candidate)" (keyup.enter)="onOpen(candidate)" hoverOnRight="admin.toolboxcandidate.show" tabindex="0">
              <td>{{ candidate.fullname_reverse }}</td>
              <td>{{ candidate.onlinetestname }}</td>
              <td>{{ candidate.translated_status_name }}</td>
              <td>{{ candidate.created_at | amLocal | amDateFormat: 'DD.MM.YYYY - HH:mm' }}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td class="no-data" colspan="4">{{ t('common.labels.no_data') }}</td>
          </tr>
        </ng-template>
      </p-table>

    </div>

  </app-list-view>
</ng-container>
